var _path, _rect;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDashboardDarkIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 4.21246C10.3009 4.21247 10.6071 4.29137 11.0303 4.48883C11.2469 4.58992 11.4849 4.71698 11.7598 4.8736L12.7129 5.43414V5.43512L13.6719 6.00641C14.4776 6.48611 15.0474 6.82638 15.4658 7.14117C15.8747 7.4488 16.101 7.70459 16.2412 7.99664C16.3811 8.28808 16.4382 8.62251 16.4209 9.13043C16.412 9.39055 16.385 9.68426 16.3428 10.0279L16.1768 11.2281L15.9834 12.5699C15.813 13.7555 15.6912 14.5979 15.5156 15.2339C15.3438 15.8561 15.1363 16.2198 14.833 16.481C14.5294 16.7425 14.1363 16.8951 13.4902 16.9761C12.8303 17.0589 11.9719 17.0601 10.7656 17.0601H9.23438C8.0281 17.0601 7.16972 17.0589 6.50977 16.9761C5.8636 16.8951 5.47065 16.7425 5.16699 16.481C4.86365 16.2198 4.65619 15.8561 4.48438 15.2339C4.35266 14.7569 4.2512 14.1639 4.13672 13.397L4.0166 12.5699L3.82324 11.2291V11.2281C3.69016 10.3045 3.59699 9.65091 3.5791 9.13043C3.56385 8.68599 3.60568 8.3742 3.70996 8.10797L3.75879 7.99664C3.89895 7.70467 4.12519 7.44885 4.53418 7.14117C4.7435 6.98372 4.99057 6.81977 5.28613 6.63531L6.32812 6.00641L7.28711 5.43512C8.01879 4.99905 8.53631 4.69112 8.96973 4.48883C9.39293 4.29132 9.69907 4.21246 10 4.21246Z",
    fill: "none",
    stroke: "white"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 7.16992,
    y: 13.8558,
    width: 5.65967,
    height: 1.15787,
    rx: 0.578934,
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardDarkIcon);
export default __webpack_public_path__ + "static/media/dashboard-dark-icon.c5d212c761d7926e09b40aaa5574fa52.svg";
export { ForwardRef as ReactComponent };